import { useAppDispatch } from "@/shared/lib/redux"
import { 
    openRecreateApiKeyModal as openRecreateApiKeyModalAction,
    openUpdateApiKeyModal as openUpdateApiKeyModalAction,
    closeUpdateApiKeyModal as closeUpdateApiKeyModalAction,
    closeRecreateApiKeyModal as closeRecreateApiKeyModalAction
} from "../../model"
import { IApiKey } from "@/shared/api/settings"

export const useUpdateApiKeyModal = () => {
    const dispatch = useAppDispatch()

    const openRecreateApiKeyModal = (data: IApiKey, onSuccess?: () => void) => {
        dispatch(openRecreateApiKeyModalAction({
            data,
            onSuccess
        }))
    }

    const openUpdateApiKeyModal = (data: IApiKey, onSuccess?: () => void) => {
        dispatch(openUpdateApiKeyModalAction({
            data,
            onSuccess
        }))
    }

    const closeRecreateApiKeyModal = () => {
        dispatch(closeRecreateApiKeyModalAction())
    }

    const closeUpdateApiKeyModal = () => {
        dispatch(closeUpdateApiKeyModalAction())
    }
    
    return {
        openRecreateApiKeyModal,
        openUpdateApiKeyModal,
        closeUpdateApiKeyModal,
        closeRecreateApiKeyModal
    }
}